/* eslint-disable import/prefer-default-export */

import createFetch from '../createFetch';
import { dateToISO8601String } from '../service/util';

const staticGoogleMapKey = process.env.GOOGLE_MAP_API_KEY;

/**
 * Get price by location
 * @param  {Object} data
 * @param  {String} data.nickname
 * @param  {String} data.phone_number
 * @param  {Object} data.order_request_detail_attributes
 * @param  {String} data.service_type
 * @param  {String} data.vehicle
 * @param  {String} data.address1
 * @param  {String} data.address2
 */
export async function getLocationPrice(data, locale) {
  const url = '/api/w1/utils/price_breakdown.json';
  const json = {
    order: {
      nickname: data.nickname,
      phone_number: data.phone_number,
      order_request_detail_attributes: data.order_request_detail_attributes,
      pickup_time: dateToISO8601String(data.pickup_time),
      service_type: data.service_type,
      vehicle: data.vehicle,
      waypoints_attributes: [data.address1, data.address2],
      goods: data.goods,
    },
  };

  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Get suggestion by location
 * @param  {String} data
 */
export async function getLocationSuggestion(data, locale, sessionToken) {
  const json = `?input=${data}&sessiontoken=${sessionToken}`;
  const url = `/api/v1/places/autocomplete.json${json}`;

  const Options = { locale };
  const options = {
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Get suggestion detail by location
 * e.g. lat, lng, address, placeid
 * @param  {String} data
 */
export async function getLocationSuggestionDetail(data, locale, sessionToken) {
  const json = `?placeid=${data}&sessiontoken=${sessionToken}`;
  const url = `/api/v1/places/details.json${json}`;

  const Options = { locale };
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Get Static Map Url
 * @param  {Object} locations
 * @param  {number} zoom
 * @param  {Object} size
 * @return {String}
 */
export function getStaticMapUrl(locations, zoom, size) {

  let nSize = {};
  if (size === null) {
    nSize = { width: 620, height: 380 };
  } else {
    nSize = size;
  }
  let url = `https://maps.googleapis.com/maps/api/staticmap?size=${
    nSize.width
    }x${nSize.height}&sensor=true&zoom=${zoom}`;

  for (let i = 0; i < locations.length; i += 1) {

    // prevent page to break when there is no location object
    if (!locations[i].location) return '';

    url = url.concat(
      `&markers=icon:http://www.gogovan.com.hk/img/map_marker_${i + 1}.png%7C${
      locations[i].location.lat
      },${locations[i].location.lon}`,
    );
  }

  url = url.concat(`&scale=1.100000023841858&key=${staticGoogleMapKey}`);

  return url;
}

// olleh map
/** convert UTMK to Lat Lng
 * @param {Object} data
 * @param {Number} data.x
 * @param {Number} data.y
 */
export function UTMKToLatlng(data) {
  return new window.olleh.maps.LatLng.valueOf(new window.olleh.maps.UTMK(data));
}

/** convert lat lng to UTMK
 * @param {Object} data
 * @param {Number} data.lat
 * @param {Number} data.lng
 */
export function latlngToUTMK(data) {
  if (
    Object.prototype.hasOwnProperty.call(data, 'lat') &&
    Object.prototype.hasOwnProperty.call(data, 'lon')
  ) {
    const d = new window.olleh.maps.LatLng(data.lat, data.lon);
    return window.olleh.maps.UTMK.valueOf(d);
  }
  return window.olleh.maps.UTMK.valueOf(new window.olleh.maps.LatLng(data));
}

// References
// http://14.63.244.28/DevSiteHtmlRenewal/innerDevelopment/download/javascript_v3_spatial/references.html#olleh.maps.Geocoder
export function geocodeCallback(data) {
  const geocoder = new window.olleh.maps.Geocoder();
  const geocoderResult = geocoder.parseGeocode(data);
  // const str_result = '';
  if (geocoderResult.count !== '0') {
    const infoArr = geocoderResult.infoarr;
    console.warn(infoArr);
    for (let i = 0; i < infoArr.length; i += 1) {
      console.warn(infoArr[i]);
    }
  }
}

export async function getAddrByParseGeocodewithFetch(position) {
  let baseUrl =
    'https://api.ollehmap.com:10083/giop/rest/geocode/Rgeocode.json?';

  const geoOptions = {
    key: process.env.OLLEH_MAP_API_KEY,
    x: position.x,
    y: position.y,
    type: 1,
    addrcdtype: 1,
    isJibun: 1,
    reqtype: 1,
    newAddr: 0,
    isMPoi: 0,
  };

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  Object.keys(geoOptions).forEach(k => {
    baseUrl = baseUrl.concat(`${k}=${geoOptions[k]}&`);
  });
  try {
    return await createFetch({})(baseUrl, options);
  } catch (e) {
    return console.warn(e);
  }
}



// WEBPACK FOOTER //
// ./src/api/map.js